<div class="vo-central-content">
  <div class="heading-image">
    <div class="logo"></div>
  </div>

  <form
    class="login-extended-functionality-container align-items-center d-flex flex-column mt-30 mx-auto"
    #resetForgottenPasswordForm="ngForm"
  >
    <div class="w-100" *ngIf="!errorMessage">
      <ng-container *ngIf="forgottenPasswordResetRequestDto?.QuestionCode">
        <div class="w-100" *ngIf="!isAnswerChecked">
          <div
            class="vo-heading-bold-24 mb-30 text-center"
            [innerHTML]="referenceDataLabels.ResetYourPassword | localizeLabel"
          ></div>
          <div
            class="vo-body-regular-14 text-center my-30"
            [innerHTML]="referenceDataLabels.PleaseAnswerSecurityQuestion | localizeLabel | toTrustedHtml"
          ></div>
          <div
            class="vo-body-bold-14 text-center my-30"
            [innerHTML]="forgottenPasswordResetRequestDto.QuestionCode | localizeOption: referenceDataOptionLists.SecurityQuestion | toTrustedHtml"
          ></div>
          <div
            class="vo-body-regular-14 text-center"
            [ngClass]="{'has-errors': (answerInput.touched || resetForgottenPasswordForm.submitted ||
        answerInput.dirty) && answerInput.invalid}"
          >
            <div
              *ngIf="(answerInput.touched || resetForgottenPasswordForm.submitted ||
          answerInput.dirty) && answerInput.invalid"
              class="error-message"
              [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage:'ForgottenPasswordAnswer' | toTrustedHtml"
            ></div>

            <div
              class="mt-15"
              *ngIf="statusCode"
              [innerHTML]="referenceDataConstants.ERROR_MESSAGE_USER_ACCOUNT | localizeErrorMessage: statusCode"
            ></div>
            <div class="vo-body-bold-14 mt-15" [innerHTML]="referenceDataLabels.Answer | localizeLabel"></div>

            <boi-text-input
              class="field-input-full-width field-text-center"
              cssClasses="label-top"
              [required]="true"
              name="Answer"
              #answerInput="ngModel"
              [(ngModel)]="forgottenPasswordResetRequestDto.Answer"
            >
            </boi-text-input>
          </div>
          <button
            class="vo-primary-button-1 w-100 mt-30"
            (click)="checkAnswer(resetForgottenPasswordForm)"
            [disabled]="!forgottenPasswordResetRequestDto.QuestionCode || !forgottenPasswordResetRequestDto.Answer"
            [innerHTML]="referenceDataLabels.ContinueId|localizeLabel"
          ></button>
        </div>
      </ng-container>

      <ng-container *ngIf="passwordResetPhoneValidated && !isAnswerChecked">
        <div
          *ngIf="passwordResetPhoneValidated.HasExceededMaximumOtpSendLimit && (passwordResetPhoneValidated.HasUserExceededMaximumOtpValidation || !passwordResetPhoneValidated.HasAnOtpCodeActive); else isValidationFormDisplayed"
          class="vo-info-box--danger-top mb-30 w-100"
        >
          {{ referenceDataLabels.VerificationCodeHasExceededMaximumOtpSendLimit | localizeLabel }}
        </div>

        <ng-template #isValidationFormDisplayed>
          <ng-container *ngIf="!isOtpSend">
            <div
              class="vo-heading-bold-24 mb-30 text-center"
              [innerHTML]="referenceDataLabels.VerificationCodeTitle | localizeLabel"
            ></div>

            <div>
              <div class="vo-body-regular-14 text-center mt-30">
                {{ referenceDataLabels.VerificationCodeInfoSend | localizeLabel }} {{
                passwordResetPhoneValidated.MaskedPhoneNumber }}
              </div>

              <button
                class="vo-primary-button-1 w-100 mt-20"
                (click)="sendCode()"
                [innerHTML]="referenceDataLabels.VerificationCodeSendButton | localizeLabel"
              ></button>
            </div>
          </ng-container>

          <ng-container *ngIf="isOtpSend">
            <div
              *ngIf="isOtpInvalid && !passwordResetPhoneValidated.HasUserExceededMaximumOtpValidation && passwordResetPhoneValidated.HasAnOtpCodeActive"
              class="vo-info-box--danger-top mb-30 w-100"
            >
              {{ referenceDataLabels.VerificationCodeInvalidOtpInfo | localizeLabel }}
            </div>

            <div
              *ngIf="passwordResetPhoneValidated.HasUserExceededMaximumOtpValidation && passwordResetPhoneValidated.HasAnOtpCodeActive && !passwordResetPhoneValidated.HasOtpNotBeenSent"
              class="vo-info-box--danger-top mb-30 w-100"
            >
              {{ referenceDataLabels.VerificationCodeHasExceededMaximumOtpValidation | localizeLabel }}
            </div>

            <div
              *ngIf="!passwordResetPhoneValidated.HasAnOtpCodeActive && !passwordResetPhoneValidated.HasOtpNotBeenSent"
              class="vo-info-box--danger-top mb-30 w-100"
            >
              {{ referenceDataLabels.VerificationCodeHasExpired | localizeLabel }}
            </div>

            <div
              [innerHtml]="referenceDataLabels.ExceededMaximumOtpSendLimitErrorMessage | localizeLabel | toTrustedHtml"
              *ngIf="passwordResetPhoneValidated.HasExceededMaximumOtpSendLimit"
              class="vo-info-box--danger-top mb-30 w-100"
            ></div>

            <div
              [innerHtml]="referenceDataLabels.OtpHasNotBeenSentErrorMessage | localizeLabel | toTrustedHtml"
              *ngIf="passwordResetPhoneValidated.HasOtpNotBeenSent && !passwordResetPhoneValidated.HasUserExceededMaximumOtpValidation"
              class="vo-info-box--danger-top mb-30 w-100"
            ></div>

            <div
              class="vo-heading-bold-24 mb-30 text-center"
              [innerHTML]="referenceDataLabels.VerificationCodeTitle | localizeLabel"
            ></div>

            <div class="vo-body-regular-14 text-center my-30">
              {{ referenceDataLabels.VerificationCodeInfoSent | localizeLabel }} {{
              passwordResetPhoneValidated.MaskedPhoneNumber }}
            </div>

            <boi-text-input
              type="text"
              [labelName]="referenceDataLabels.VerificationCodeEnterInputLabel"
              [(ngModel)]="otpCode"
              [required]="true"
              cssClasses="label-top label-weight-bold"
              class="field-input-full-width mb-10 mt-0 field-text-center"
            >
            </boi-text-input>

            <button
              [disabled]="(blockResend && passwordResetPhoneValidated.HasUserExceededMaximumOtpValidation) || (blockResend && !passwordResetPhoneValidated.HasAnOtpCodeActive) || passwordResetPhoneValidated.HasUserExceededMaximumOtpValidation"
              class="vo-primary-button-1 w-100 mt-30"
              (click)="validateOtpCode(resetForgottenPasswordForm)"
              [innerHTML]="referenceDataLabels.Continue | localizeLabel"
            ></button>

            <button
              [disabled]="passwordResetPhoneValidated.HasExceededMaximumOtpSendLimit || blockResend"
              class="vo-primary-button-2 w-100 mt-20"
              (click)="sendCode()"
              [innerHTML]="referenceDataLabels.VerificationCodeReSendButton | localizeLabel"
            ></button>
          </ng-container>
        </ng-template>

        <a class="vo-link d-flex justify-content-center mt-30" [routerLink]="['../../login']"
          >{{ referenceDataLabels.BackToLoginButton | localizeLabel }}</a
        >
      </ng-container>

      <div class="w-100" *ngIf="isAnswerChecked">
        <div
          class="vo-heading-bold-24 mb-30 text-center"
          [innerHTML]="referenceDataLabels.CreateNewPassword | localizeLabel"
        ></div>
        <div
          class="vo-body-regular-14 text-center my-15"
          [innerHTML]="referenceDataLabels.CreateNewPasswordSecurityInfo | localizeLabel"
        ></div>
        <div
          class="vo-body-regular-14 text-center"
          [ngClass]="{'has-errors': (passwordInput.touched || resetForgottenPasswordForm.submitted ||
              passwordInput.dirty) && passwordInput.invalid}"
        >
          <div
            *ngIf="(passwordInput.touched || resetForgottenPasswordForm.submitted ||
                      passwordInput.dirty) && passwordInput.invalid"
            class="error-message mb-15"
            [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage:'PasswordToHash' | toTrustedHtml"
          ></div>

          <boi-validation-error-generic
            class="d-block mb-15"
            [validationErrors]="validationErrors"
            [propertyNames]="['PasswordToHash', 'PasswordMinimumLength', 'PasswordMissingLowerCharacter', 'PasswordMissingUpperCharacter', 'PasswordMissingSpecialCharacter', 'PasswordUsedPreviously']"
          >
          </boi-validation-error-generic>

          <boi-text-input
            [type]="'password'"
            [labelName]="referenceDataLabels.UserResetPasswordNew"
            name="password"
            #passwordInput="ngModel"
            [canShowPassword]="true"
            [(ngModel)]="forgottenPasswordResetRequestDto.Password"
            [required]="true"
            cssClasses="label-top label-weight-bold"
            class="field-input-full-width mb-10 mt-0 field-text-center"
          >
          </boi-text-input>
        </div>
        <boi-password-strength
          class="password-strength__container mb-30 vo-body-regular-14"
          [passwordToCheck]="forgottenPasswordResetRequestDto.Password"
        >
        </boi-password-strength>
        <div
          class="vo-body-regular-14 text-center"
          [ngClass]="{'has-errors': (confirmPasswordInput.touched || resetForgottenPasswordForm.submitted ||
                  confirmPasswordInput.dirty) && confirmPasswordInput.invalid}"
        >
          <div
            *ngIf="(confirmPasswordInput.touched || resetForgottenPasswordForm.submitted ||
                      confirmPasswordInput.dirty) && confirmPasswordInput.invalid && (confirmPasswordInput.errors | firstKey) === 'required'"
            class="error-message mb-15"
            [innerHTML]="referenceDataConstants.ERROR_MESSAGE_ME000 | localizeErrorMessage:'ConfirmationPassword' | toTrustedHtml"
          ></div>

          <div
            *ngIf="(confirmPasswordInput.touched || resetForgottenPasswordForm.submitted ||
                      confirmPasswordInput.dirty) && confirmPasswordInput.invalid && (confirmPasswordInput.errors | firstKey) === 'mustMatch'"
            class="error-message mb-15"
            [innerHTML]="referenceDataConstants.ERROR_MESSAGE_EQ000 | localizeErrorMessage:'ConfirmationPassword' | toTrustedHtml"
          ></div>
          <boi-text-input
            [type]="'password'"
            [labelName]="referenceDataLabels.ConfirmNewPassword"
            name="confirmPassword"
            #confirmPasswordInput="ngModel"
            [canShowPassword]="true"
            [(ngModel)]="forgottenPasswordResetRequestDto.ConfirmPassword"
            [required]="true"
            [boiMustMatch]="forgottenPasswordResetRequestDto.Password"
            cssClasses="label-top label-weight-bold"
            class="field-input-full-width mb-10 mt-0 field-text-center"
          >
          </boi-text-input>
        </div>

        <button
          class="vo-primary-button-1 w-100 my-30"
          (click)="resetForgottenPassword(resetForgottenPasswordForm)"
          [innerHTML]="referenceDataLabels.Save|localizeLabel"
          [disabled]="resetForgottenPasswordForm.invalid || forgottenPasswordResetRequestDto.Password !== forgottenPasswordResetRequestDto.ConfirmPassword"
        ></button>
      </div>
    </div>

    <div
      *ngIf="errorMessage"
      class="vo-body-regular-14 text-center my-30"
      [innerHTML]="errorMessage.Name | localizeErrorMessage: errorMessage.Code : [errorMessage.Arguments] | toTrustedHtml"
    ></div>
  </form>
</div>
